import BorderStyle from './_border-style.js'
import ConfigurableText from './_configurable-text.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import SelectionButtonInfoText from './_selection-button-info-text.js'
import Image from './_image.js'
import SportsDisplayFormat from './_sports-display-format.js'
import Arrowhead from './_arrowhead.js'
import HideablePane from './_hideable-pane.js'
import Animation from './_animation.js'

export default {
  name: 'SelectionButtonView',
  values: {
    l10nLabel: undefined,
    handicapDisplay: true,
    borderStyle: {
      configSet: BorderStyle,
      configValues: {
        borderRadius: '2px',
      },
    },
    padding: '4px',
    background: {
      inactive: undefined,
      inactivehover: undefined,
      active: undefined,
      activehover: undefined,
      disabled: undefined,
    },
    minHeight: '40px',
    height: '44px',
    width: '100%',
    layoutDirection: 'vertical',
    contentContainer: {
      vertical: {
        style: {
          padding: undefined,
        },
        itemSpacing: undefined,
      },
      horizontalAlignLeft: {
        style: {
          padding: '0 10px 0 10px',
        },
        itemSpacing: '10px',
      },
      horizontalAlignCenter: {
        style: {
          padding: undefined,
        },
        itemSpacing: '10px',
      },
    },
    applyPriceChangeTextColor: true,
    priceText: {
      ellipsize: true,
      base: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      vertical: {
        textAlign: 'center',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      horizontalAlignLeft: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      horizontalAlignCenter: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      inactive: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      active: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
      decreaseColor: undefined,
      increaseColor: undefined,
    },
    infoTextContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    infoText: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          textAlign: 'center',
        },
      },
    },
    infoTextHandicapBase: {
      configSet: Text,
      configValues: {
        truncate: false,
        container: {
          flexShrink: 0,
          alignSelf: 'end',
        },
      },
    },
    infoTextOverrides: {
      vertical: {
        $mixin: [
          {
            configSet: SelectionButtonInfoText,
          },
        ],
      },
      horizontalAlignLeft: {
        textAlign: 'left',
        $mixin: [
          {
            configSet: SelectionButtonInfoText,
          },
        ],
      },
      horizontalAlignCenter: {
        $mixin: [
          {
            configSet: SelectionButtonInfoText,
          },
        ],
      },
      active: {
        $mixin: [
          {
            configSet: SelectionButtonInfoText,
          },
        ],
      },
      inactive: {
        $mixin: [
          {
            configSet: SelectionButtonInfoText,
          },
        ],
      },
    },
    unavailable: {
      $mixin: [
        {
          configSet: ConfigurableText,
        },
      ],
    },
    msPriceChangeTimeout: 3000,
    lockedIcon: {
      configSet: Image,
      configValues: {
        src: 'padlock-filled',
        style: {
          fill: '#b4b4b4',
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    showPrice: true,
    setGameMarketTypes: [
      '262',
      '211',
    ],
    sportsDisplayFormat: {
      configSet: SportsDisplayFormat,
      configValues: {},
    },
    nameDisplay: 'show',
    _mobile_nameDisplay: 'show short',
    showSetGameInfoText: false,
    priceTextEllipsis: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    showPriceChangeIndicators: true,
    priceChangeIndicators: {
      arrowheadUp: {
        configSet: Arrowhead,
        configValues: {
          size: '12px',
          style: undefined,
        },
      },
      arrowheadDown: {
        configSet: Arrowhead,
        configValues: {
          size: '12px',
          style: undefined,
        },
      },
      transition: {
        configSet: HideablePane,
        configValues: {
          style: {
            toVisibleTransition: {
              transitionDuration: '2s',
            },
          },
        },
      },
    },
    animation: {
      configSet: Animation,
      configValues: {
        animationDuration: '0.3s',
        keyframes: {
          from: {
            opacity: 0.5,
          },
          to: {
            opacity: 1,
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
